import React from 'react'
import Layout from './Layout'
import PuntajeGeneralSection from '../sections/PuntajeGeneralSection'

const PuntajeGeneral = () => {
    return (
        <Layout>
            <div style={{ marginTop: "75px" }}>
                <PuntajeGeneralSection />
            </div>
        </Layout>
    )
}

export default PuntajeGeneral